<template>
    <div>
        <HeaderSection icon="fas fa-cogs" title="Configuración">
            <template slot="buttons">
                <el-button
                        type="danger"
                        @click="$router.push('/')"
                        icon="el-icon-arrow-left">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>

        <el-tabs v-model="activeNames"  type="card">
            <el-tab-pane label="Cátalogos Administrativos" name="admin"><CatalogTable/></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import HeaderSection from '../../../partials/HeaderSection';
    import CatalogTable from './partials/CatalogTable';

    export default {
        components: {HeaderSection,CatalogTable},

        data(){
            return{
                activeNames: 'admin'
            }
        },

    }
</script>

<style scoped>

</style>